var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0007 7.00005C16.0007 6.44776 16.4484 6.00005 17.0007 6.00005C17.553 6.00005 18.0007 6.44776 18.0007 7.00005C18.0007 7.55233 17.553 8.00005 17.0007 8.00005C16.4484 8.00005 16.0007 7.55233 16.0007 7.00005Z",
    fill: "#6C6D6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0007 7.25005C9.37732 7.25005 7.25067 9.37669 7.25067 12C7.25067 14.6234 9.37732 16.75 12.0007 16.75C14.624 16.75 16.7507 14.6234 16.7507 12C16.7507 9.37669 14.624 7.25005 12.0007 7.25005ZM8.75067 12C8.75067 10.2051 10.2057 8.75005 12.0007 8.75005C13.7956 8.75005 15.2507 10.2051 15.2507 12C15.2507 13.795 13.7956 15.25 12.0007 15.25C10.2057 15.25 8.75067 13.795 8.75067 12Z",
    fill: "#6C6D6D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2589 2.83306C13.7924 2.44562 10.209 2.44562 6.74244 2.83306C4.73038 3.05794 3.10605 4.64295 2.8695 6.66548C2.45496 10.2098 2.45496 13.7903 2.8695 17.3346C3.10605 19.3571 4.73038 20.9422 6.74244 21.167C10.209 21.5545 13.7924 21.5545 17.2589 21.167C19.271 20.9422 20.8953 19.3571 21.1319 17.3346C21.5464 13.7903 21.5464 10.2098 21.1319 6.66548C20.8953 4.64295 19.271 3.05794 17.2589 2.83306ZM6.90905 4.32378C10.2649 3.94871 13.7365 3.94871 17.0923 4.32378C18.4224 4.47244 19.4879 5.52205 19.642 6.83973C20.043 10.2683 20.043 13.7318 19.642 17.1604C19.4879 18.478 18.4224 19.5277 17.0923 19.6763C13.7365 20.0514 10.2649 20.0514 6.90905 19.6763C5.57894 19.5277 4.51346 18.478 4.35934 17.1604C3.95834 13.7318 3.95834 10.2683 4.35934 6.83973C4.51346 5.52205 5.57894 4.47244 6.90905 4.32378Z",
    fill: "#6C6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.9c735f7edf5908df55cc3abe6c73e363.svg";
export { ForwardRef as ReactComponent };